<template>
  <div>
    <p class="ml-5 text-black font-weight-bold">
      {{ authUser.grade_name }} / {{ selectedCycle.cycle_name }} / Estude agora
    </p> 
    <v-container fluid>
      <v-card rounded="sm">
        <v-card-text class="py-0">
          <p class="ml-md-4 mt-4 my-2 font-weight-semibold font-16 text-theme">
            Conteúdos e resultados
          </p>
        </v-card-text>
        <v-card-text :class="{ 'p-0' : isMobile }">
          <v-container fluid>
            <v-row>
              <v-col md="6">
                <v-card
                  class="bg-custom-light-gray-2 mb-2"
                  rounded="sm"
                >
                  <p class="ml-4 font-weight-semibold font-16 mt-4 mb-2 text-black">
                    Módulos
                  </p>
                  <v-card-text
                    v-for="(module, index) in modules"
                    :key="index"
                  >
                    <ModuleCard :module="module" />
                  </v-card-text>
                  <p class="ml-4 font-weight-semibold font-16 mt-2 text-black">
                    Desafio
                  </p>
                  <v-card-text>
                    <ChallengeCard :cycle="selectedCycle" />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="6">
                <v-card
                  class="bg-custom-light-gray-2 mb-2"
                  rounded="sm"
                >
                  <v-card-text>
                    <div class="bg-custom-light-blue rounded p-2">
                      <v-btn
                        color="nitro"
                        small
                      >
                        <span class="first-letter-capitalize white--text">
                          Desempenho no ciclo
                        </span>
                      </v-btn>
                    </div>
                  </v-card-text>
                  <v-card-text>
                    <CyclePerformanceGraphic 
                      v-if="selectedCycle.challenge && selectedCycle.challenge.finished_at && selectedCycle.challenge_result_released"
                    />
                    <p
                      v-else
                      class="font-14 m-0"
                    >
                      Gráfico não disponível.
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import ModuleCard from "./components/ModuleCard.vue";
import ChallengeCard from "./components/ChallengeCard.vue";
import CyclePerformanceGraphic from "./components/CyclePerformanceGraphic.vue";

export default {
  components: {
    ModuleCard, 
    ChallengeCard,
    CyclePerformanceGraphic,
  },
  computed: {
    ...mapGetters(['selectedCycle','view_plan','authUser']),
    modules(){
      return this.selectedCycle.plan == 'full' ? this.selectedCycle.modules : this.selectedCycle.modules.filter(m => !m.block_id);
    }
  },
}
</script>
